<template>
  <div class="bg position-relative">
    <div class="background-top">
      <div class="bc">
        <img class="img_1" src="/img/image/home/t_8.png" loading="lazy" alt="美味的享用方式"/>
        <img class="img_2" src="/img/image/home/main_img3.png" loading="lazy" alt/>
        <div class="img_space"/>

        <div class="w-100">
          <div class="info_area row ">

            <div class="col-auto info_item">
              <div class="image-container">
                <img src="/img/image/home/dec_1.png" loading="lazy" alt="保存方法">
                <div class="text-title">保存方法</div>
              </div>
              <div style="height: 20px;"/>
              <div class="text-primary eat_area_info">放置於冷藏或冷凍保藏</div>
              <div style="height: 8px;"/>
              <div class="eat_area_info">
                <span class="text-custom-text">冷藏可保存</span>
                <span class="text-primary">7天</span>
              </div>
              <div style="height: 8px;"/>
              <div class="eat_area_info">
                <span class="text-custom-text">冷凍可保存</span>
                <span class=" position-relative text-primary">6個月
                <img class="bottom_line" src="/img/image/home/dec_2.png" loading="lazy" alt>
                </span>
              </div>
            </div>
            <div class="space_1"/>
            <div class="col-auto info_item ">
              <div class="image-container">
                <img src="/img/image/home/dec_3.png" loading="lazy" alt="加熱方式">
                <div class="text-title">加熱方式</div>
              </div>
              <div style="height: 20px;"/>
              <div class="eat_area_info text-custom-text">
                烤箱
                <span class="text-custom-text2">180度 6分鐘</span>
              </div>
              <div style="height: 8px;"/>
              <div class="eat_area_info text-custom-text">
                氣炸鍋
                <span class="text-custom-text2">180度 6分鐘</span>
              </div>
              <div style="height: 8px;"/>


              <div class="eat_area_info">
                <span class=" position-relative text-custom-text">切片煎乾至兩面金黃
                <img class="bottom_line" src="/img/image/home/dec_4.png" loading="lazy" alt>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 60px"/>
        <div class="row no-gutters button_area">
          <button type="button" class="btn btn-outline-primary button_style" @click="clickBuy">
            <div class="row no-gutters justify-content-center align-items-center">
            <span class="button_text">
              立即購買
            </span>
              <div class="button_space"/>
              <img class="button_icon" src="/img/image/icon/arrow-2.png" loading="lazy" alt>
            </div>
          </button>
        </div>
        <div class="down_space"/>
      </div>
    </div>
    <div class="background-bottom"/>
  </div>
</template>

<script>
export default {
  name: "Stage_3",
  methods: {
    clickBuy() {
      const tasteNow = document.getElementById('taste_now');
      tasteNow.scrollIntoView({behavior: 'smooth'});
    },
  },
}
</script>

<style lang="scss" scoped>

.bg {
  //max-height: 1155px;
  //background-image: url('/img/image/background/bg_s14.png');
  //background-size: cover;
  //background-position: center;
  //background-repeat: repeat;
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
}


.background-top, .background-bottom {
  background-size: cover;
  background-position: center;
  width: 100%;
}

.background-top {
  background-image: url('/img/image/background/bg_s5.png');
  height: 400px;
}

@media (max-width: 576px) {
  .background-top {
    height: 195px;
  }
}

.background-bottom {
  background-color: #FFFEE9;
  height: 755px;
}

@media (max-width: 1350px) {
  .background-bottom {
    height: 1200px;
  }
}

@media (max-width: 576px) {
  .background-bottom {
    height: 1000px;
  }
}

@media (max-width: 400px) {
  .background-bottom {
    height: 900px;
  }
}

//文字 美翠的享用方式
.img_1 {
  padding-top: 73px;
  padding-left: 87px;
  width: 532px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 576px) {
  .img_1 {
    padding: 0;
    width: 55vw;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
}


//肉圖
.img_2 {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1213px;
  width: 84vw;
  height: auto;
  object-fit: cover;
}

@media (max-width: 1440px) {
  .img_2 {
    //top: 24vw;
    width: 84vw;
  }
}

@media (max-width: 1350px) {
  .img_2 {
    top: 23%;
  }
}

@media (max-width: 992px) {
  .img_2 {
    width: 91vw;
  }
}

@media (max-width: 576px) {
  .img_2 {
    top: 15%;
    width: 91vw;
  }
}

@media (max-width: 400px) {
  .img_2 {
    top: 17%;
    width: 90vw;
  }
}

.img_space {
  height: 437px;
}

@media (max-width: 576px) {
  .img_space {
    height: 340px;
  }
}


.info_area {
  justify-content: space-between;
  padding-left: 13.75rem !important;
  padding-right: 13.75rem !important;
}

@media (max-width: 1350px) {
  .info_area {
    padding: 0 !important;
    justify-content: center;
  }
}


.space_1 {
  width: 0;
  height: 0;
}

@media (max-width: 1350px) {
  .space_1 {
    width: 100%;
    height: 125px;
  }
}


.info_item {
  width: 470px;
}

@media (max-width: 576px) {
  .info_item {
    width: 67vw;
  }
}

@media (max-width: 480px) {
  .info_item {
    width: 80vw;
  }
}

@media (max-width: 400px) {
  .info_item {
    width: 90vw;
  }
}


.text-title {
  position: absolute;
  width: max-content;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  color: white;
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
}

@media (max-width: 576px) {
  .text-title {
    font-size: 32px;
  }
}

@media (max-width: 425px) {
  .text-title {
    font-size: 26px;
  }
}

@media (max-width: 370px) {
  .text-title {
    font-size: 24px;
  }
}

@media (max-width: 340px) {
  .text-title {
    font-size: 22px;
  }
}


.eat_area_info {
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: left;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .eat_area_info {
    font-size: 32px;
  }
}

@media (max-width: 425px) {
  .eat_area_info {
    font-size: 26px;
  }
}

@media (max-width: 370px) {
  .eat_area_info {
    font-size: 24px;
  }
}

@media (max-width: 340px) {
  .eat_area_info {
    font-size: 22px;
  }
}



.image-container {
  position: relative;
  display: inline-block;
}

// 保存方法 加熱方式
.image-container img {
  width: 312px;
  height: auto;
}

@media (max-width: 576px) {
  .image-container img {
    width: 52vw;
  }
}

//保存方式的 底線圖片
.bottom_line {
  position: absolute;
  bottom: -25px;
  right: 0;
  max-width: 108px;
  width: 108px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 576px) {
  .bottom_line {
    width: 18vw;
  }
}


.button_area {
  padding-right: 13.75rem !important;
  padding-left: 13.75rem !important;
}

@media (max-width: 992px) {
  .button_area {
    padding-top: 60px;
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
}

@media (max-width: 576px) {
  .button_area {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
}

.button_style {
  width: 100%;
  height: 90px;
  border-radius: 10px;
  border: 2px solid #D56835;
  background-color: transparent;
  color: #D56835;
}

@media (max-width: 576px) {
  .button_style {
    height: 45px;
    padding: 0;
  }
}

.button_style:active {
  background-color: transparent !important;
  color: #D56835;
}

.button_style:focus {
  background-color: transparent !important;
  color: #D56835;
}

.button_style:hover {
  background-color: transparent !important;
  color: #D56835;
}

.button_text {
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-align: center;
  color: #D56835;
}


@media (max-width: 576px) {
  .button_text {
    font-size: 24px;
  }
}

@media (max-width: 360px) {
  .button_text {
    font-size: 18px;
  }
}

.button_space {
  width: 16px;
}

@media (max-width: 576px) {
  .button_space {
    width: 0;
    height: 0;
  }
}

.button_icon {
  width: 48px;
  height: 48px
}

@media (max-width: 576px) {
  .button_icon {
    width: 0;
    height: 0;
    visibility: hidden;
  }
}

.down_space {
  height: 90px;
}

@media (max-width: 576px) {
  .down_space {
    height: 48px;
  }
}

</style>
